import React, { type MouseEvent } from 'react';

import * as styles from './styles';
import { BodyText, CloseButton, DescriptionTitle, Popper } from '..';

import { Button } from '@cobliteam/ui/components';

import { WarningRounded } from '@material-ui/icons';

export interface CloseDrawerButtonProps {
  shouldConfirm: boolean;
  onCloseConfirmed: (event: MouseEvent<HTMLButtonElement>) => void;
  onCloseCancelled?: () => void;
  className?: string;
  customTitle?: string;
  customBodyText?: string;
}

export const CloseDrawerButton: React.FC<CloseDrawerButtonProps> = ({
  shouldConfirm,
  onCloseConfirmed,
  onCloseCancelled,
  className,
  customTitle,
  customBodyText,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [open, setOpen] = React.useState(false);

  const handleCloseCancelled = () => {
    setOpen(false);

    if (onCloseCancelled) {
      onCloseCancelled();
    }
  };

  const handleCloseConfirmed = (event: MouseEvent<HTMLButtonElement>) => {
    setOpen(false);
    onCloseConfirmed(event);
  };

  const onCloseButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (shouldConfirm) {
      setOpen(true);
    } else {
      handleCloseConfirmed(event);
    }
  };

  return (
    <span ref={ref} className={className || ''}>
      <CloseButton onClick={onCloseButtonClick} />
      <Popper arrow open={open} placement='left-start' anchorEl={ref?.current}>
        <div className={styles.close}>
          <div className={styles.closeTitle}>
            <WarningRounded className={styles.closeTitleIcon} />
            <DescriptionTitle>
              {customTitle || 'Fechar sem salvar?'}
            </DescriptionTitle>
          </div>
          <BodyText>
            {customBodyText || 'Você editou informações que não foram salvas.'}
          </BodyText>
          <div className={styles.closeActions}>
            <Button variant='text' onClick={handleCloseCancelled}>
              Cancelar
            </Button>
            <Button
              color='danger'
              size='condensed'
              onClick={handleCloseConfirmed}
              className='min-w-28'
            >
              Fechar
            </Button>
          </div>
        </div>
      </Popper>
    </span>
  );
};
